import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Common from '../../../common/src/assets/js/common';
import routerPush from "../../../common/src/assets/js/router";
import beforeEach from '../../../common/src/assets/js/routerBeforeEach';
VueRouter.prototype.push = routerPush.prototype.push;
Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: 'general'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/general',
    name: 'General',
    meta: {page: 'main', menu: 'main'},
    component: () => import(/* webpackChunkName: "general" */ '../views/general/general.vue'),
  },
  {
    path: '/authentication',
    name: 'Authentication',
    meta: {page: 'main', menu: 'main'},
    component: () => import(/* webpackChunkName: "general" */ '../views/authentication/authentication.vue'),
  },
  {
    path: '/authenticationinfo',
    name: 'AuthenticationInfo',
    meta: {page: 'main', menu: 'main'},
    component: () => import(/* webpackChunkName: "general" */ '../views/authenticationinfo/authenticationinfo.vue'),
  },
  {
    path: '/payment',
    name: 'Payment',
    meta: {page: 'pull'},
    component: () => import(/* webpackChunkName: "general" */ '../views/payment/payment.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    meta: {page: 'pull', notLogin: true,},
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    meta: {page: 'pull', notLogin: true,},
    component: () => import(/* webpackChunkName: "login" */ '../views/register/register.vue'),
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {page: 'pull', notLogin: true,},
    component: () => import(/* webpackChunkName: "login" */ '../views/reset-password/reset-password.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/manage',
  routes,
});
// 全局导卫
beforeEach(router, Vue)
export default router;
